<figure [ngClass]="['gup-C-avatar',avatarSizeClassName]">

    <img (error)="handlePictureError()"
         *ngIf="!hasPictureError && !!pictureUrl else noImage"
         [alt]="initial"
         [src]="pictureUrl | sanitize:'url'"
         class="gup-C-avatar__picture initial">

    <ng-template #noImage>
    <span class="initial">
        {{initial}}
    </span>
    </ng-template>

</figure>
